import { useScopedPathnameFactory } from '../core/factories/routing/routingHooks.factories'
import { type RouteName } from './routes'

// eslint-disable-next-line react-hooks/rules-of-hooks
export const useScopedPathname = useScopedPathnameFactory<RouteName>()
